import { motion } from "framer-motion";

export default function PieChart({ title, data, img }) {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="glass-card rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10"
    >
      <h3 className="text-base md:text-lg text-text-[#FD5B38] text-center mb-6 md:mb-10">
        {title}
      </h3>

      <div className="flex flex-col items-center gap-6 md:gap-8">
        <img
          src={img}
          alt="Pie Chart"
          className="w-auto h-auto object-contain"
        />

        <div className="flex flex-col gap-2 w-full max-w-xs">
          {data.map((item, index) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 + 0.1 * index }}
              className="flex items-center justify-between gap-4"
            >
              <div className="flex items-center gap-2 md:gap-3">
                <div
                  className="w-4 h-4 md:w-5 md:h-5 rounded-full flex-shrink-0"
                  style={{ backgroundColor: item.color }}
                />
                <span className="text-sm md:text-base text-text-secondary">
                  {item.label}
                </span>
              </div>
              <span className="text-sm md:text-base text-text-[#FD5B38]">
                {((item.value / total) * 100).toFixed(1)}%
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
